import config from '../config/config';

const UNIT_METER = config.common.unit.meter;
const ELEVATION_UNKNOWN_LABEL = config.map.elev.unknownLabel;

const ICON_URLS = {
  mountain: `${config.icons.baseUrl}${config.icons.mountain}`,
};

/**
 * 標高コンポーネント
 */
const ElevationInfo = ({ elevation }) => {

  // 手前の処理で「値、または不明ラベル」がセットされている
  const isUnknown = elevation === ELEVATION_UNKNOWN_LABEL;
  const displayValue = isUnknown ? '' : elevation;

  return (
    <div className="elevation-info">
      <i
        className="svg-icon-blue"
        style={{
          backgroundImage: `url('${ICON_URLS.mountain}')`
        }}
      ></i>
      <span>
        {/* 標高値 */}
        <span id="elevation-value">{displayValue}</span>

        {/* 単位は不明ラベルでない場合のみ表示 */}
        {!isUnknown && (
          <span id="elevation-unit">{UNIT_METER}</span>
        )}
      </span>
    </div>
  );
};

export default ElevationInfo;